module.exports = __webpack_public_path__ + "img/35874-112.9bab993e.jpg";